/* import __COLOCATED_TEMPLATE__ from './entity.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface TasksKitListEntitySignature {
  Args: {
    dueDateIdPrefix: unknown;
    entities: unknown;
    entityResourceName: unknown;
    hideAddButton: unknown;
    isAutoResolvable: unknown;
    isLoading: unknown;
    newDisabled: unknown;
    onDelete: unknown;
    onDraft: unknown;
    onResolve: unknown;
    onSelect: unknown;
    onSubmit: unknown;
    readonlyTasks: unknown;
    resourceName: unknown;
    selectedTask: unknown;
    selectedView: unknown;
    taskResourceName: unknown;
    taskType: unknown;
    tasks: unknown;
  };
}

const TasksKitListEntityComponent = templateOnlyComponent<TasksKitListEntitySignature>();

export default TasksKitListEntityComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::Entity': typeof TasksKitListEntityComponent;
    'tasks-kit/list/entity': typeof TasksKitListEntityComponent;
  }
}
